<template>
  <div class="not-found">
    <div class="container text-center py-5">
      <h1 class="display-1 fw-bold text-primary">404</h1>
      <h2 class="mb-4">Page Not Found</h2>
      <p class="lead mb-5">The page you are looking for doesn't exist or has been moved.</p>
      <div class="d-flex justify-content-center gap-3">
        <router-link to="/" class="btn btn-primary">
          Go Home
        </router-link>
        <button class="btn btn-outline-primary" @click="goBack">
          Go Back
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundView',
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.not-found {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>